import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Ver docs em apps/crm/src/hooks/usePlatformCutoverFlag.ts (duplicação
 * intencional — single-hook feature, não justifica pacote compartilhado
 * por ora).
 */
export function usePlatformCutoverFlag() {
  return useQuery({
    queryKey: ["platform", "cutover-flag"],
    staleTime: 5 * 60_000,
    queryFn: async (): Promise<boolean> => {
      const { data, error } = await supabase
        .from("platform_settings")
        .select("value")
        .eq("key", "admin_cutover_enabled")
        .maybeSingle();
      if (error) return false;
      const v = data?.value as { enabled?: boolean } | null;
      return Boolean(v?.enabled);
    },
  });
}

export const ADMIN_APP_URL = "https://admin.playprosport.com.br";
